/* eslint-disable @typescript-eslint/naming-convention */
import { ILocalization } from '@shared-ui/localization-context';

export interface IQueryAdapter {
  parseIn(query: any): any;
  parseOut(query: any): any;
}

export interface IRoomQueryAdapter {
  parseIn(query: any): any;
  parseOut(query: any, l10n: ILocalization): any;
  parseInRoomParams(query: any): any;
  parseInGuestParams(query: any): any;
}

export function queryObject(query: any): any {
  if (typeof query !== 'object' || !query) {
    return {};
  }

  return Object.assign({}, query);
}
